export default "__VITE_ASSET__dPhdS8J8__"